import { Injectable } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';

@Injectable({
    providedIn: 'root'
})
export class ConfirmationService {
    constructor(private modal: NzModalService) {}

    /**
     * Shows a confirmation modal if condition is true, otherwise executes action immediately
     * @param condition - Whether to show the confirmation modal
     * @param onConfirm - Callback to execute when user confirms (clicks OK)
     * @param onProceedWithoutConfirm - Optional callback when condition is false. If not provided, uses onConfirm
     * @param onCancel - Optional callback when user cancels (clicks Cancel)
     */
    async confirmUpdateTask (
        condition: boolean,
        onConfirm: () => void | Promise<void>,
        onCancel?: () => void | Promise<void>,
        onProceedWithoutConfirm?: () => void | Promise<void>,
    ): Promise<void> {
        if (!condition) {
            // No confirmation needed, execute the alternate action or default to onConfirm
            await (onProceedWithoutConfirm || onConfirm)();
            return;
        }
        // Show confirmation modal
        this.modal.confirm({
            nzTitle: `There are inactive users associated with this task. Do you still want to proceed?`,
            nzOkText: 'Yes',
            nzCancelText: 'No',
            nzOkType: 'primary',
            nzOkDanger: true,
            nzStyle: { top: '40vh' },
            nzOnOk: async () => {
                await onConfirm();
            },
            nzOnCancel: async () => {
                if (onCancel) {
                    await onCancel();
                }
            }
        });
    }
}
